import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { loaderStateTrue, loaderStateFalse, handleActiveLink, setChatDocView } from '../../../../Actions/AllAction';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

function PricingAnalyticsChart(props) {
    const { datasets, labels } = props;
    // console.log("datasets====", datasets)
    // console.log("labels====", labels)

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    boxWidth: 10,
                    boxHeight: 10,
                },
            },
            title: {
                display: true,
                text: 'Message Delivery Volume by Pricing Category',
                font: {
                    size: 12,
                    weight: 'bold',
                },
                padding: {
                    top: 10,
                    bottom: 20,
                },
            },
            tooltip: {
                mode: 'index',
                intersect: false,
            },
        },
        scales: {
            y: {
                title: {
                    display: true,
                    text: 'Delivered Message Volume',
                    font: { size: 12, weight: 'bold' },
                },
                beginAtZero: true,
                ticks: {
                    stepSize: 5,
                },
            },
            x: {
                title: {
                    display: true,
                    text: 'Date (Start date)',
                    font: { size: 12, weight: 'bold' },
                },
                ticks: {
                    // autoSkip: true,
                    // maxRotation: 45,
                    // minRotation: 45,
                    callback: function (value, index) {
                        return labels[index];
                    },
                },
            },
        },
    };

    const data = {
        labels,
        datasets,
    };

    return (
        <div style={{ height: '355px', width: '100%' }}>
            <Line data={data} options={options} />
        </div>
    );
}

const mapStateToProps = (globalState) => ({
    userCredentials: globalState.LoginReducer.userCredentials,
    userLoginDetails: globalState.LoginReducer.userLoginDetails,
    token: globalState.LoginReducer.token,
    localTimeZoneName: globalState.mainReducerData.localTimeZone,
    version: globalState.LoginReducer.version,
});

export default connect(
    mapStateToProps,
    { handleActiveLink, loaderStateTrue, loaderStateFalse, setChatDocView }
)(withRouter(PricingAnalyticsChart));
